import React, { useState } from "react";
import { ReactSortable } from "react-sortablejs";
import BuilderTabs from "../../Layouts/BuilderTabs";
import { AdvanceEditForDetailviewField } from "../../Pages/ApplicationBlock/DetailsViewRenderer/Desktop/EditDetailsviewFields";
import { getDefaultConfig } from "../../utils/Config/getDefaultConfig";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import Button from "../FormComponents/Button";
import EditPositionButtonConfig from "./EditPositionButtonConfig";
import { generateObjectId } from "../../utils/objectIdUtils";
import Input from "../FormComponents/Input";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import ClassSelectorLayout from "../ClassSelectorLayout/ClassSelectorLayout";

const EditButtonGroup = ({
  editElementData,
  setEditElementData,
  smId,
  device,
  elements,
  places,
  positionClasses = false,
  tableType = "statemachine"
}) => {
  const handleChange = (name, newButtonList) => {
    setEditElementData({
      ...editElementData,
      [name]: newButtonList
    });
  };
  return (
    <div>
      {device === "mobile" && (
        <Input
          type="checkbox"
          checked={editElementData.disable_floating}
          label="Disable Floating Position"
          onChange={(e) => handleChange("disable_floating", e.target.checked)}
          containerClassName="ml_3"
        />
      )}
      <ButtonListEditor
        list={editElementData?.button_list || []}
        onChange={(list) => handleChange("button_list", list)}
        places={places}
        device={device}
        elements={elements}
        tableId={smId}
        positionClasses={positionClasses}
        tableType={tableType}
      />
    </div>
  );
};

const ButtonListEditor = ({
  list,
  onChange,
  places,
  device,
  elements,
  // positionClasses = false,
  tableId,
  tableType = "statemachine"
}) => {
  const [selectedButtonId, setSelectedButtonId] = useState(null);

  const addButton = (type) => {
    const defaultButtonConfig = getDefaultConfig(type);
    const btnId = generateObjectId();
    const newButton = { id: btnId, ...defaultButtonConfig };
    onChange([...list, newButton]);
    setSelectedButtonId(btnId);
  };

  const updateButton = (config) => {
    const updatedList = list.map((button) => (button.id === selectedButtonId ? { ...button, ...config } : button));
    onChange(updatedList);
  };

  const deleteButton = (e, id) => {
    e.stopPropagation();
    const updatedList = list.filter((button) => button.id !== id);
    onChange(updatedList);
    if (selectedButtonId === id) {
      setSelectedButtonId(null);
    }
  };

  const handleListOrderChange = (newList) => {
    onChange(newList);
  };

  const makeButtonConfig = () => {
    const selectedConfig = list.find((button) => button.id === selectedButtonId);
    return selectedConfig;
  };

  return (
    <div className="button_group_config_outer">
      <div className="d_flex p_3 gap_2">
        <Button onClick={() => addButton("button")}>Add Button</Button>
        <Button onClick={() => addButton("dropdown")}>Add Dropdown</Button>
      </div>
      <div className="button_selected_form">
        <div className="button_inside_selected">
          <ReactSortable
            list={list.map((item) => ({ ...item }))}
            setList={handleListOrderChange}
            className="left_panel_field_container cursor_move"
            animation="200"
            easing="ease-out"
          >
            {list?.map((button) => (
              <div
                key={button.id}
                className={`button_column_list ${selectedButtonId === button.id ? "selected" : ""}`}
                onClick={() => setSelectedButtonId(button.id)}
              >
                <div className="d_flex align_center">
                  {button.icon?.split(" ")?.[0] && <MaterialIcon name={button.icon.split(" ")[0]} />}
                  <span>{button.name}</span>
                </div>
                <ButtonActionIcon onClick={(e) => deleteButton(e, button.id)} type="delete" />
              </div>
            ))}
          </ReactSortable>
        </div>
        <hr className="button_selected_break_line" />
        <div style={{ width: "488px" }}>
          {selectedButtonId !== null && (
            <ButtonConfigWithStyles
              config={makeButtonConfig()}
              onChange={updateButton}
              tableId={tableId}
              tableType={tableType}
              places={places}
              device={device}
              elements={elements}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const ButtonConfigWithStyles = ({ config, onChange, tableId, tableType, places, device, elements }) => {
  const handleClasses = (classes) => {
    onChange({ ...config, classes: classes });
  };
  const handleEditElementData = (type, data) => {
    onChange({ ...config, [type]: data });
  };
  const tabsData = [
    {
      label: "Config",
      content: (
        <EditPositionButtonConfig
          editElementData={config}
          setEditElementData={onChange}
          tableID={tableId}
          tableType={tableType}
          places={places}
          type={config.type}
          device={device}
          actionElements={elements}
        />
      )
    },
    {
      label: "Style",
      content: (
        <ClassSelectorLayout
          id={config.id}
          defaultSelected={config.classes || []}
          onChange={handleClasses}
          type={config.type}
        />
      )
    },
    {
      label: "Advanced",
      content: (
        <div style={{ overflow: "visible" }} className="form_basic_field_wrapper sidebar-edit-option-outer">
          <AdvanceEditForDetailviewField
            editElementData={config}
            onChange={handleEditElementData}
            tableID={tableId}
            device={device}
          />
        </div>
      )
    }
  ];
  return <BuilderTabs tabs={tabsData} />;
};

export default EditButtonGroup;
export { ButtonListEditor };
